<script setup lang="ts">
import { computed } from 'vue';
import type { MatrixColumn, MatrixRow } from '../../util/answerRecapMatrix';
import HostResultsDialog from './results/HostResultsDialog.vue';
import PlayerAnswerRow from './results/PlayerAnswerRow.vue';
import useLocale from '../../../composables/use-locale';

const props = defineProps<{
  modelValue: boolean;
  row: MatrixRow | null;
  columns: MatrixColumn[];
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const { t } = useLocale();

// Skipped questions are counted out separately rather than as wrong answers.
const subtitle = computed(() => {
  if (!props.row) {
    return '';
  }
  const { correct, answered, total } = props.row;
  const summary = t('results.answer_recap.player_summary', { correct, answered });
  const unanswered = total - answered;
  return unanswered > 0 ? `${summary} · ${t('results.answer_recap.unanswered_count', { count: unanswered })}` : summary;
});
</script>

<template>
  <HostResultsDialog
    :model-value="modelValue"
    :title="row?.label ?? ''"
    :subtitle="subtitle"
    test-id="quizter-player-detail"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template v-if="row">
      <PlayerAnswerRow
        v-for="(cell, index) in row.cells"
        :key="columns[index].questionId"
        :cell="cell"
        :column="columns[index]"
      />
    </template>
  </HostResultsDialog>
</template>
